export type CATEGORIES = 'ucak-bileti' | 'otel' | 'otobus-bileti' | 'arac-kiralama' | 'transfer' | 'dinamik'

export const PRODUCT_CATEGORIES: Record<CATEGORIES, number> = {
  'ucak-bileti': 0,
  'otel': 1,
  'otobus-bileti': 2,
  'arac-kiralama': 3,
  'transfer': 4,
  'dinamik': 5,
}
